import FooterContainer_TransparentScreenComponent from '@wix/thunderbolt-elements/src/components/FooterContainer/viewer/skinComps/BaseScreen/TransparentScreen.skin';


const FooterContainer_TransparentScreen = {
  component: FooterContainer_TransparentScreenComponent
};


export const components = {
  ['FooterContainer_TransparentScreen']: FooterContainer_TransparentScreen
};

